import { Typography } from "antd";
const { Text } = Typography;
function DetailMetaField({ label, children }) {
  return (
    <span className="project-type-meta-field">
      <Text strong className="project-type-meta-label">
        {label}
      </Text>
      <Text className="project-type-meta-value">{children}</Text>
    </span>
  );
}
export default DetailMetaField;
